import * as actions from "Actions";
import * as api from "Api";

export const fetchUsers = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    const { searchWord, role } = getState().authorizationsSettings.filter;
    let organizationId = currentOrganization.id;

    return dispatch(
      actions.getUsersSettings(
        api.getUsersSettings(searchWord, role, organizationId)
      )
    );
  };
};

export const updateUsersSettings = () => {
  return (dispatch, getState) => {
    let {
      role,
      activateNotifications,
      activateCarteNotifications,
      activateCalendarNotifications,
      allowConfigurateBudget,
      allowAccessToClientInformations,
      allowAccessToGlobalBudget,
      allowUpdatingOffrePrice,
      allowToAddDeleger,
      allowUpdateBudgetedBenchmark,
      allowUpdatingBillingView,
      allowUpdatingTarifClients,
      allowUpdatingNewClients,
      allowUpdatingDepartClients,
      allowAccessToClientCollaboratorRelation,
      allowAccessToStatisticsCards,
      allowAccessToCorrectionCards,
      allowVisualizationOfBudgetedTime,
      allowVisualizationOfBudgetedBenchmark,
      allowVisualizationOfRealizedTime,
      allowVisualizationOfRealizedBenchmark,

      allowAdjustDistributionOfTasksByRole,
      allowAttributionBU,
      allowAttributionSquad,
      allowCollabToDevCard,
      allowAttributionCluster,
      allowSelectAppliedModel,
      allowTodragAndDropFromTODO,
      allowTodragAndDropFromWIP,
      allowTodragAndDropFromDONE,
      allowTodragAndDropFromVALIDATION,
      allowAccessClientSpace,
      allowAccessToClientList,
      allowCreateCorrectionCards,
      allowAccessToCollaboratorList,

      allowAccessReporting,
      allowAccessReportingTab,
      allowAccessProductionCapacity,
      allowAccessBonusPlan,
      allowAccessEcheance,
      allowAccessBalanceRecap,
      allowAccessCalendar,
      allowAccessTimeReport,
      allowAccessPortfolio,
      allowAccessErrReporting,
      allowAccessVacationMatrix,
      allowAccessPlans,
      allowAccessPrestation,

      allowAccessPrestaTS,
      allowAccessFinancial,
      allowAccessFinancialSheet,
      allowAccessForfait,
      allowAccessCroissance,
      allowAccessDynamicTable,

      allowAccessCapacityPlanning,
      allowAccessCapacityPlanningTab,
      allowAccessSynthesis,

      allowAccessSetting,
      allowAccessCategorySetting,
      allowAccessTaskTypeSetting,
      allowAccessCollaboratorSetting,
      allowAccessCalendarSetting,
      allowCoefficientsConfig,
      allowAccessModelSetting,
      allowAccessUserSetting,
      allowAccessSynchronization,
      allowAccessParameterSetting,

      dashboard,
      clients,
      collaborators,
      prestations,
      financial,
      reporting,
      notifications,
      capacityPlanning,
      settings,
      timesheet,

      selectedUsers
    } = getState().authorizationsSettings;
    let clientId = getState().auth.currentOrganization.id;

    let selectedUsersIds = selectedUsers.map(user => user.id);

    if (role !== "NONE") {
      return dispatch(
        actions.saveUsers(
          api
            .saveUsersSettings(
              role,
              activateNotifications ? 1 : 0,
              activateCarteNotifications ? 1 : 0,
              activateCalendarNotifications ? 1 : 0,
              allowAccessClientSpace ? 1 : 0,
              allowConfigurateBudget ? 1 : 0,
              allowUpdatingBillingView ? 1 : 0,
              allowUpdatingTarifClients ? 1 : 0,
              allowUpdatingNewClients ? 1 : 0,
              allowUpdatingDepartClients ? 1 : 0,
              allowAccessToClientCollaboratorRelation ? 1 : 0,
              allowAccessToClientInformations ? 1 : 0,
              allowAccessToGlobalBudget ? 1 : 0,
              allowUpdatingOffrePrice ? 1 : 0,
              allowToAddDeleger ? 1 : 0,
              allowUpdateBudgetedBenchmark ? 1 : 0,
              allowAccessToStatisticsCards ? 1 : 0,
              allowAccessToCorrectionCards ? 1 : 0,
              allowVisualizationOfBudgetedTime ? 1 : 0,
              allowVisualizationOfBudgetedBenchmark ? 1 : 0,
              allowVisualizationOfRealizedTime ? 1 : 0,
              allowVisualizationOfRealizedBenchmark ? 1 : 0,

              allowAdjustDistributionOfTasksByRole ? 1 : 0,
              allowAttributionBU ? 1 : 0,
              allowAttributionSquad ? 1 : 0,
              allowCollabToDevCard ? 1 : 0,
              allowAttributionCluster ? 1 : 0,
              allowSelectAppliedModel ? 1 : 0,
              allowTodragAndDropFromTODO ? 1 : 0,
              allowTodragAndDropFromWIP ? 1 : 0,
              allowTodragAndDropFromDONE ? 1 : 0,
              allowTodragAndDropFromVALIDATION ? 1 : 0,
              allowAccessToClientList ? 1 : 0,
              allowCreateCorrectionCards ? 1 : 0,
              allowAccessToCollaboratorList ? 1 : 0,

              allowAccessReporting ? 1 : 0,
              allowAccessReportingTab ? 1 : 0,
              allowAccessProductionCapacity ? 1 : 0,
              allowAccessBonusPlan ? 1 : 0,
              allowAccessEcheance ? 1 : 0,
              allowAccessBalanceRecap ? 1 : 0,
              allowAccessCalendar ? 1 : 0,
              allowAccessTimeReport ? 1 : 0,
              allowAccessPortfolio ? 1 : 0,
              allowAccessErrReporting ? 1 : 0,
              allowAccessVacationMatrix ? 1 : 0,
              allowAccessPlans ? 1 : 0,
              allowAccessPrestation ? 1 : 0,

              allowAccessPrestaTS ? 1 : 0,
              allowAccessFinancial ? 1 : 0,
              allowAccessFinancialSheet ? 1 : 0,
              allowAccessForfait ? 1 : 0,
              allowAccessCroissance ? 1 : 0,
              allowAccessDynamicTable ? 1 : 0,

              allowAccessCapacityPlanning ? 1 : 0,
              allowAccessCapacityPlanningTab ? 1 : 0,
              allowAccessSynthesis ? 1 : 0,

              allowAccessSetting ? 1 : 0,
              allowAccessCategorySetting ? 1 : 0,
              allowAccessTaskTypeSetting ? 1 : 0,
              allowAccessCollaboratorSetting ? 1 : 0,
              allowAccessCalendarSetting ? 1 : 0,
              allowCoefficientsConfig ? 1 : 0,
              allowAccessModelSetting ? 1 : 0,
              allowAccessUserSetting ? 1 : 0,
              allowAccessSynchronization ? 1 : 0,
              allowAccessParameterSetting ? 1 : 0,

              dashboard,
              clients,
              collaborators,
              prestations,
              financial,
              reporting,
              capacityPlanning,
              settings,
              timesheet,
              notifications,

              selectedUsersIds,
              clientId
            )
            .then(res =>
              dispatch(
                actions.updateUsers({
                  role,
                  activateNotifications: activateNotifications ? 1 : 0,
                  activateCarteNotifications: activateCarteNotifications
                    ? 1
                    : 0,
                  activateCalendarNotifications: activateCalendarNotifications
                    ? 1
                    : 0,
                  allowConfigurateBudget: allowConfigurateBudget ? 1 : 0,
                  allowUpdatingBillingView: allowUpdatingBillingView ? 1 : 0,
                  allowUpdatingTarifClients: allowUpdatingTarifClients ? 1 : 0,
                  allowUpdatingNewClients: allowUpdatingNewClients ? 1 : 0,
                  allowUpdatingDepartClients: allowUpdatingDepartClients
                    ? 1
                    : 0,
                  allowAccessToClientCollaboratorRelation: allowAccessToClientCollaboratorRelation
                    ? 1
                    : 0,
                  allowAccessToStatisticsCards: allowAccessToStatisticsCards
                    ? 1
                    : 0,
                  allowAccessToCorrectionCards: allowAccessToCorrectionCards
                    ? 1
                    : 0,
                  allowVisualizationOfBudgetedTime: allowVisualizationOfBudgetedTime
                    ? 1
                    : 0,
                  allowVisualizationOfBudgetedBenchmark: allowVisualizationOfBudgetedBenchmark
                    ? 1
                    : 0,
                  allowVisualizationOfRealizedTime: allowVisualizationOfRealizedTime
                    ? 1
                    : 0,
                  allowVisualizationOfRealizedBenchmark: allowVisualizationOfRealizedBenchmark
                    ? 1
                    : 0,
                  allowAccessClientSpace: allowAccessClientSpace ? 1 : 0,
                  allowAccessToClientList: allowAccessToClientList ? 1 : 0,
                  allowAccessToCollaboratorList: allowAccessToCollaboratorList
                    ? 1
                    : 0,
                  allowCreateCorrectionCards: allowCreateCorrectionCards
                    ? 1
                    : 0,
                  selectedUsers: selectedUsersIds
                })
              )
            )
        )
      );
    } else {
      return dispatch(
        actions.saveUsers(
          api.deleteUsersSettings(selectedUsersIds, clientId).then(res =>
            dispatch(
              actions.updateUsers({
                selectedUsers: selectedUsersIds
              })
            )
          )
        )
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/authorizations.js